module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('selectBox')], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('drugList')], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "取消全選"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.unCheckAll($event)
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始移除"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f8037c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RemoveDrug.vue
// module id = 1428
// module chunks = 1